export default __webpack_public_path__ + "static/media/Quickadd.c5d7f782.svg";